(function () {
  'use strict';

  if (window.CrestCardSavedUI) return;

  window.CrestCardSavedUI = true;

  const loader = document.querySelector(
    'script[data-crest-saved-ui]'
  );

  const cartURL =
    loader?.dataset.cartUrl ||
    (window.Shopify?.routes?.root || '/') + 'cart';

  function safeURL(value, image = false) {
    if (!value) return '';

    try {
      const url = new URL(value, location.origin);

      if (
        ['https:', 'http:'].includes(url.protocol) &&
        (
          url.origin === location.origin ||
          (image && url.hostname === 'cdn.shopify.com')
        )
      ) {
        return url.href;
      }
    } catch (_) {}

    return '';
  }

  class SavedToast {
    constructor() {
      this.node = document.createElement('aside');
      this.node.className = 'crest-saved-toast';
      this.node.hidden = true;

      this.node.setAttribute(
        'aria-label',
        'Notifica prodotti salvati'
      );

      this.node.innerHTML = `
        <div>
          <img
            class="crest-saved-toast__image"
            alt=""
            width="42"
            height="54"
            hidden
          >

          <span
            class="crest-saved-toast__mark"
            aria-hidden="true"
          >♥</span>
        </div>

        <div>
          <div
            role="status"
            aria-live="polite"
            aria-atomic="true"
          >
            <span class="crest-saved-toast__brand">
              CREST / LA TUA SELEZIONE
            </span>

            <strong class="crest-saved-toast__title"></strong>
            <span class="crest-saved-toast__text"></span>
            <span class="crest-saved-toast__caption"></span>
          </div>

          <a class="crest-saved-toast__link"></a>
        </div>

        <button
          type="button"
          class="crest-saved-toast__close"
          aria-label="Chiudi notifica"
        >×</button>
      `;

      document.body.append(this.node);

      this.pauses = new Set();

      this.node.querySelector('button').addEventListener(
        'click',
        () => this.hide()
      );

      this.node.addEventListener(
        'mouseenter',
        () => this.pause('mouse')
      );

      this.node.addEventListener(
        'mouseleave',
        () => this.resume('mouse')
      );

      this.node.addEventListener(
        'focusin',
        () => this.pause('focus')
      );

      this.node.addEventListener('focusout', event => {
        if (!this.node.contains(event.relatedTarget)) {
          this.resume('focus');
        }
      });

      this.node.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.hide();
        }
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.pause('page');
        } else {
          this.resume('page');
        }
      });
    }

    pause(reason) {
      if (!this.pauses.size && this.timer) {
        this.remaining = Math.max(
          0,
          this.deadline - performance.now()
        );

        clearTimeout(this.timer);
        this.timer = null;
      }

      this.pauses.add(reason);
    }

    resume(reason) {
      this.pauses.delete(reason);
      this.arm();
    }

    arm() {
      if (
        this.node.hidden ||
        this.pauses.size ||
        this.timer ||
        !this.open
      ) {
        return;
      }

      this.deadline = performance.now() + this.remaining;

      this.timer = setTimeout(
        () => this.hide(),
        this.remaining
      );
    }

    show(record = {}, options = {}) {
      clearTimeout(this.timer);
      clearTimeout(this.hideTimer);

      if (this.frame) {
        cancelAnimationFrame(this.frame);
      }

      this.timer = null;
      this.invoker = options.invoker;
      this.node.hidden = false;

      this.pauses.clear();

      if (document.hidden) {
        this.pauses.add('page');
      }

      if (this.node.contains(document.activeElement)) {
        this.pauses.add('focus');
      }

      if (
        window.matchMedia?.('(hover: hover)')?.matches &&
        this.node.matches(':hover')
      ) {
        this.pauses.add('mouse');
      }

      const error = options.kind === 'error';
      const removed = options.kind === 'remove';
      const cartAdded = options.kind === 'cart';

      const title = error
        ? 'Salvataggio non riuscito'
        : cartAdded
          ? 'Aggiunto al carrello'
          : removed
            ? 'Rimosso dai salvati'
            : options.kind === 'exists'
              ? 'Già nei salvati'
              : 'Prodotto salvato';

      this.node.setAttribute(
        'aria-label',
        cartAdded ? 'Notifica carrello' : 'Notifica prodotti salvati'
      );

      this.node.querySelector(
        '.crest-saved-toast__brand'
      ).textContent = cartAdded
        ? 'CREST / IL TUO CARRELLO'
        : 'CREST / LA TUA SELEZIONE';

      this.node.querySelector(
        '.crest-saved-toast__title'
      ).textContent = title;

      this.node.querySelector(
        '.crest-saved-toast__text'
      ).textContent = error
        ? options.message || 'Riprova tra un momento.'
        : [record.title, record.format]
            .filter(Boolean)
            .join(' · ');

      this.node.querySelector(
        '.crest-saved-toast__caption'
      ).textContent = error
        ? ''
        : cartAdded
          ? Number(record.quantity) + ' pz aggiunti al carrello.'
          : removed
            ? 'Il contenuto del carrello resta invariato.'
            : 'Lo ritrovi in “Salvati per dopo” nel carrello.';

      const image = this.node.querySelector('img');
      const source = safeURL(record.image, true);

      image.hidden = !source;

      if (source) {
        image.src = source;
      } else {
        image.removeAttribute('src');
      }

      const mark = this.node.querySelector(
        '.crest-saved-toast__mark'
      );

      mark.hidden = Boolean(source);
      mark.textContent = error
        ? '!'
        : cartAdded
          ? '✓'
          : removed
            ? '♡'
            : '♥';

      const link = this.node.querySelector('a');

      link.href = safeURL(options.href || cartURL) || cartURL;
      link.textContent = options.linkLabel ||
        (cartAdded ? 'Vedi carrello' : 'Vedi salvati');
      link.hidden = error && !options.href;

      this.remaining = error ? 7000 : cartAdded ? 3000 : 4500;
      this.open = true;

      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.node.classList.add('is-visible');
        this.arm();
      });
    }

    hide() {
      this.open = false;

      clearTimeout(this.timer);
      this.timer = null;

      if (this.frame) {
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      if (
        this.node.contains(document.activeElement) &&
        this.invoker?.isConnected
      ) {
        this.invoker.focus();
      }

      this.node.classList.remove('is-visible');

      this.hideTimer = setTimeout(() => {
        this.node.hidden = true;
      }, 220);
    }
  }

  let toast;

  window.CrestSavedToast = {
    show(record, options) {
      (toast ||= new SavedToast()).show(record, options);
    }
  };

  customElements.define(
    'crest-save-card',
    class extends HTMLElement {
      connectedCallback() {
        if (this.bindings) return;

        this.card = this.closest(
          '.crest-featured__card,.crest-cere__card,.crest-product-card'
        );

        if (!this.card) return;

        try {
          this.product = JSON.parse(
            this.querySelector(
              '[data-card-saved-data]'
            ).textContent
          );
        } catch (_) {
          return;
        }

        this.button = this.querySelector('.crest-card-save');
        this.bindings = new AbortController();

        const signal = this.bindings.signal;

        this.schedule = () => {
          if (this.frame) return;

          this.frame = requestAnimationFrame(() => {
            this.frame = null;

            if (this.isConnected) {
              this.draw();
            }
          });
        };

        this.button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.toggle();
        }, { signal });

        this.card.addEventListener(
          'change',
          this.schedule,
          { signal }
        );

        this.card.addEventListener(
          'input',
          this.schedule,
          { signal }
        );

        document.addEventListener(
          'crest-saved:updated',
          this.schedule,
          { signal }
        );

        window.addEventListener(
          'storage',
          this.schedule,
          { signal }
        );

        window.addEventListener(
          'pageshow',
          this.schedule,
          { signal }
        );

        this.observer = new MutationObserver(records => {
          if (
            records.some(
              record => !this.contains(record.target)
            )
          ) {
            this.schedule();
          }
        });

        this.observer.observe(this.card, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: [
            'value',
            'checked',
            'disabled',
            'aria-pressed'
          ]
        });

        this.hidden = false;
        this.draw();
      }

      disconnectedCallback() {
        this.bindings?.abort();
        this.bindings = null;

        this.observer?.disconnect();

        if (this.frame) {
          cancelAnimationFrame(this.frame);
        }

        this.frame = null;
      }

      selection() {
        const form = this.card.querySelector(
          'form.crest-featured__form,' +
          'form.crest-cere__form,' +
          'form.crest-grid-cart-form'
        );

        const input = form?.elements.namedItem('id');

        const id = input
          ? String(input.value)
          : this.product.defaultOnly
            ? this.product.variants[0]?.id
            : '';

        const variant = this.product.variants.find(
          item => item.id === id
        );

        if (
          !variant ||
          variant.requiresPlan ||
          (!form && variant.min > 1)
        ) {
          return null;
        }

        const quantityField =
          form?.elements.namedItem('quantity');

        return {
          variant,
          quantityField,
          quantity: quantityField
            ? Number(quantityField.value)
            : 1
        };
      }

      draw() {
        const api = window.CrestSharedSaved;
        const selected = this.selection();

        let saved = false;

        if (selected && api?.read) {
          try {
            saved = api.read().some(
              item => item.uid === selected.variant.id
            );
          } catch (_) {}
        }

        this.button.disabled =
          !api?.read ||
          !api?.save ||
          !api?.remove;

        this.button.setAttribute(
          'aria-pressed',
          String(saved)
        );

        const label = saved
          ? 'Rimuovi dai salvati'
          : 'Salva per dopo';

        const format =
          selected && !this.product.defaultOnly
            ? ' — ' + selected.variant.title
            : '';

        this.button.setAttribute(
          'aria-label',
          label + ': ' + this.product.title + format
        );

        this.button.title = label;
      }

      toggle() {
        const api = window.CrestSharedSaved;

        if (this.button.disabled) return;

        let record;
        let kind;

        try {
          const selected = this.selection();

          if (!selected) {
            window.CrestSavedToast.show({}, {
              kind: 'error',
              message:
                'Apri la scheda prodotto per scegliere ' +
                'il formato e salvarlo.',
              href: this.product.url,
              linkLabel: 'Apri prodotto',
              invoker: this.button
            });

            return;
          }

          const id = selected.variant.id;

          record = {
            uid: id,
            variant: id,
            quantity: selected.quantity,
            title: this.product.title,
            format: this.product.defaultOnly
              ? ''
              : selected.variant.title,
            url:
              this.product.url +
              (
                this.product.url.includes('?')
                  ? '&'
                  : '?'
              ) +
              'variant=' +
              id,
            image:
              selected.variant.image ||
              this.product.image ||
              ''
          };

          if (api.read().some(item => item.uid === id)) {
            api.remove(id);
            kind = 'remove';
          } else {
            if (
              !Number.isSafeInteger(selected.quantity) ||
              selected.quantity < 1 ||
              (
                selected.quantityField &&
                !selected.quantityField.checkValidity()
              )
            ) {
              throw Error(
                'Inserisci una quantità valida prima di salvare.'
              );
            }

            kind = api.save(record, false)
              ? 'save'
              : 'exists';
          }
        } catch (error) {
          window.CrestSavedToast.show({}, {
            kind: 'error',
            message: error.message,
            invoker: this.button
          });

          return;
        }

        try {
          api.sync();
        } catch (error) {
          console.warn(
            'CREST sincronizzazione salvati',
            error
          );
        }

        this.draw();

        window.CrestSavedToast.show(record, {
          kind,
          invoker: this.button
        });
      }
    }
  );
})();